import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { prefersReducedMotion } from "../utils";

const LEAVE_DURATION_MS = 250;

// Keeps rendering the previous page while it fades out, then swaps to the new
// one. Query-string changes (e.g. product category filters) swap immediately.
const usePageTransition = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const isLeaving = location.pathname !== displayLocation.pathname;

  useEffect(() => {
    if (!isLeaving) return;
    const timeout = setTimeout(
      () => {
        window.scrollTo(0, 0);
        setDisplayLocation(location);
      },
      prefersReducedMotion() ? 0 : LEAVE_DURATION_MS
    );
    return () => clearTimeout(timeout);
  }, [isLeaving, location]);

  return {
    displayLocation: isLeaving ? displayLocation : location,
    isLeaving,
  };
};

export default usePageTransition;
